export const normalizeCartItemsForOrder = (items = []) =>
  items.map((it) => {
    const qty = Math.max(1, Number(it.quantity || 1));

    const finalUnit = Number(it.unitPrice ?? it.listPrice ?? 0);
    const finalTotal = Number(it.totalPrice ?? finalUnit * qty);

    const breakdown = Array.isArray(it.discountsApplied)
      ? it.discountsApplied
      : [];

    // 👇 carry plural or singular customizations (fallback-safe)
    const uiCustoms =
      Array.isArray(it.customizations) && it.customizations.length
        ? it.customizations
        : Array.isArray(it.customization)
        ? it.customization
        : [];

    // Attempt to reconstruct the original unit if available
    const originalUnit =
      typeof it._originalUnitPrice === "number"
        ? it._originalUnitPrice
        : Number(
            (
              (finalTotal +
                breakdown.reduce((s, d) => s + Number(d.amount || 0), 0)) /
              qty
            ).toFixed(2)
          );

    const originalTotal =
      typeof it._originalTotalPrice === "number"
        ? it._originalTotalPrice
        : Number((originalUnit * qty).toFixed(2));

    return {
      productId: it.productId || it._id || it.id || null,
      name: it.name,
      displayName: it.displayName || null,
      category: it.category,
      subcategory: it.subcategory || null,
      image: it.image,
      referenceImages: it.referenceImages || [],
      size: it.size || null,
      flavor: it.flavor || null,
      quantity: qty,
      originalUnitPrice: Number(originalUnit.toFixed(2)),
      originalTotalPrice: Number(originalTotal.toFixed(2)),
      unitPrice: Number(finalUnit.toFixed(2)),
      totalPrice: Number(finalTotal.toFixed(2)),
      customizations: uiCustoms, // ✅ ensured
      note: it.note || "",
      discountsApplied: breakdown.map((d) => ({
        ruleId: d.ruleId ?? null,
        name: d.name,
        type: d.type,
        valueType: d.valueType,
        value: d.value,
        priority: d.priority,
        exclusive: !!d.exclusive,
        amount: Number(Number(d.amount || 0).toFixed(2)),
        matchedOn: {
          productType: d.matchedOn?.productType ?? null,
          category: d.matchedOn?.category ?? null,
          subcategory: d.matchedOn?.subcategory ?? null,
        },
      })),
    };
  });

export default normalizeCartItemsForOrder;
